export function getYearOfSimpleDate(date: string) {
  return date.split('-')[0];
}
